var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-primary"},[_c('Widget',[(_vm.title)?_c('div',{staticClass:"title-info"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }